module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.productsByType), function(productType) {
    return _c('document-container', {
      key: productType.type,
      attrs: {
        "footer": productType.template.footer(),
        "header": productType.template.header(),
        "logo": _vm.logo,
        "tables": productType.tables,
        "documentType": "multi-report",
        "orientation": "landscape"
      }
    }, [_c('div', {
      attrs: {
        "slot": "raw-header"
      },
      slot: "raw-header"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": _vm.logo,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "header"
    }, [_c('span', {
      staticClass: "supertitle"
    }, [_vm._v("Advisory Mandat")]), _vm._v(" "), _c('pagetitle', {
      attrs: {
        "data": {
          title: productType.template.config.title.title.toUpperCase()
        }
      }
    })], 1)]), _vm._v(" "), _vm._l((productType.tables.tables), function(table) {
      return _c('div', {
        staticClass: "page-block",
        attrs: {
          "slot": "raw-body"
        },
        slot: "raw-body"
      }, [_c('multi-report-table', {
        key: table.id,
        attrs: {
          "id": table.id,
          "table": table
        }
      })], 1)
    }), _vm._v(" "), _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-footer"
      },
      slot: "raw-footer"
    }, [_c('div', [_vm._v("\n        Quelle: BNP Paribas Wealth Management, Stand: " + _vm._s(_vm.time) + ". Indikationen sind freibleibend und unterliegen\n        Schwankungen\n      ")]), _vm._v(" "), _c('hr')])], 2)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-584eee4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/multi-report/MultiReport.vue
// module id = 685
// module chunks = 0